// Configuration des variables d'environnement
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yeliigame-production.up.railway.app/api';

// Validation des variables d'environnement requises
export const validateEnv = () => {
    const requiredVars = [
        'REACT_APP_API_URL'
    ];

    const missingVars = requiredVars.filter(varName => !process.env[varName]);
    
    if (missingVars.length > 0) {
        console.warn('Variables d\'environnement manquantes:', missingVars);
        console.warn('Utilisation des valeurs par défaut');
    }
};

// Configuration par défaut
export const config = {
    apiUrl: API_BASE_URL,
    cacheTimeout: 5 * 60 * 1000, // 5 minutes
    maxRetries: 3,
    retryDelay: 1000 // 1 seconde
}; 